module.exports = __webpack_public_path__ + "static/media/Calendar.8080da48.svg";